import BtnRestart from './BtnRestart';
import Header from './Header';
import Recommendation from './Recommendation';
import Table from './Table';

const Result = ({ result, weight, prefer, goBack }) => {
  return (
    <div className="box">
      <Header weight={weight} prefer={prefer} />
      <Table result={result} />
      <Recommendation />
      <BtnRestart goBack={goBack} />
    </div>
  );
};

export default Result;
